// Assign Code Basic
export const ASSIGN_CODE_REQUEST = 'ASSIGN_CODE_REQUEST';
export const ASSIGN_CODE_DONE = 'ASSIGN_CODE_DONE';
export const ASSIGN_CODE_FAILED = 'ASSIGN_CODE_FAILED';
export const ASSIGN_CODE_RESET = 'ASSIGN_CODE_RESET';